export const GET_ATTIVITA_BY_TIPO_CORSO_START_ACTION = 'GET_ATTIVITA_BY_TIPO_CORSO_START_ACTION';
export const GET_ATTIVITA_BY_TIPO_CORSO_SUCCESS = 'GET_ATTIVITA_BY_TIPO_CORSO_SUCCESS';
export const GET_ATTIVITA_BY_TIPO_CORSO_FAIL = 'GET_ATTIVITA_BY_TIPO_CORSO_FAIL';

export const GET_ALL_TIPI_ATTIVITA_SUCCESS = 'GET_ALL_TIPI_ATTIVITA_SUCCESS';
export const GET_ALL_TIPI_ATTIVITA_FAIL = 'GET_ALL_TIPI_ATTIVITA_FAIL';

export const INSERT_TIPO_ATTIVITA_SUCCESS = 'INSERT_TIPO_ATTIVITA_SUCCESS';

export const UPDATE_SUCCESS = 'UPDATE_SUCCESS';
export const INIT_UPDATE_FIELDS = 'INIT_UPDATE_FIELDS';

export const INIT_ATTIVITA_BY_TIPO_CORSO = 'INIT_ATTIVITA_BY_TIPO_CORSO';

